import React, { Component } from 'react';
import Button from "components/CustomButtons/Button.js";
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import classNames from "classnames";
import SnackbarContent from "components/Snackbar/SnackbarContent.js";
import Warning from "@material-ui/icons/Warning";
import { FormControlLabel, Checkbox, Select, TextField, MenuItem } from "@material-ui/core";
import Check from "@material-ui/icons/Check";
import { FcCheckmark } from "react-icons/fc";
import Typography from "@material-ui/core/Typography";
import { getSelectedCustomer, getQloadCustomerList } from '../../../store/actions';
import { connect } from 'react-redux';
import history from '../../../../../src/history';
import Simplert from 'react-simplert';
import validator from 'validator'
import { dataController } from '../../../store/api/api.js';
import authService from 'components/api-authorization/AuthorizeService';

import {
    container,
    title,
    main,
    mainRaised,
    mrAuto,
    whiteColor,
    blackColor,
    infoColor,
    mlAuto,
    hexToRgb,
} from "../../../../assets/jss/material-kit-pro-react.js";
import { isEmpty } from "lodash";

const useStyles = theme => ({
    main,
    mainRaised,
    mrAuto,
    mlAuto,
    container: {
        ...container,
        zIndex: 2,
    },
    title: {
        ...title,
        "&, & + h4": {
            /*            color: whiteColor,*/
        },
    },
    textCenter: {
        textAlign: "center",
    },
    block: {
        color: "inherit",
        padding: "0.9375rem",
        fontWeight: "500",
        fontSize: "12px",
        textTransform: "uppercase",
        borderRadius: "3px",
        textDecoration: "none",
        position: "relative",
        display: "block",
    },
    inlineBlock: {
        display: "inline-block",
        padding: "0px",
        width: "auto",
    },
    list: {
        marginBottom: "0",
        padding: "0",
        marginTop: "0",
    },
    left: {
        float: "left!important",
        display: "block",
    },
    right: {
        margin: "0",
        float: "right!important",
        display: "block",
    },
    icon: {
        width: "18px",
        height: "18px",
        top: "3px",
        position: "relative",
    },
    subHeader: {
        ...title,
        "&, & + h2": {
        },
        padding: "20px 0 10px 0", textAlign: "justify"
    },
    content: {
        paddingBottom: "30px",
        paddingTop: "20px",
    },
    checked: {
        color: infoColor[0] + "!important",
    },
    checkedIcon: {
        width: "25px",
        height: "25px",
        border: "0.5px solid rgba(" + hexToRgb(blackColor) + ", 0.54)",
        borderRadius: "3px",
    },
    uncheckedIcon: {
        width: "25px",
        height: "25px",
        padding: "9px",
        border: "0.5px solid rgba(" + hexToRgb(blackColor) + ", .54)",
        borderRadius: "3px",
    },
    closebuttonPopUp: {
        backgroundColor: "#006666", border: "none", color: "white", padding: "15px 28px", textAlign: "center",
        textDecoration: "none", display: "inline-block", margin: "13px 2px", cursor: "pointer"
    },
     confirmbuttonPopUp: {
         backgroundColor: "#00b300", border: "none", color: "white", padding: "15px 28px", textAlign: "center",
        textDecoration: "none", display: "inline-block", margin: "13px 2px", cursor: "pointer"
    },
    checkRoot: {
        padding: "14px",
        "&:hover": {
            backgroundColor:
                "rgba(" + hexToRgb(infoColor[0]) + ", 0.14) !important",
        },
    }
});





const productCat = [
    {
        value: "1",
        label: "Fencing"
    },
    {
        value: "2",
        label: "Drainage"
    },

];


class EditCusotmerFields extends Component {


    state = {
        username: '',
        userSavedInStore: false,
        page: 0,
        rowsPerPage: 10,

        customerData: [],
        _customerId: 0,
        email: '',
        telephone: null,
        nmbsRefer: '',
        active: false,
        test: false,
        customerListQload: '',

        userUpdatedSuccess: false,

        //pop up message
        showAlert: false,
        typeAlert: '',
        titleAlert: '',
        messageAlert: '',
    }

    componentDidMount() {

        //NEED TO RESET SELECTED CUSTOMER WHEN LEAVING PAGE OR UPDATING USER TO NULL

        this.props.getSelectedCustomer(this.props.selectedCus);
        this.PopulateDropdownList();
        if (this.props.selectedCus !== null && this.props.qloadCuslist !== null) {
            this.setState({
                customerData: this.props.selectedCus,
                active: this.props.selectedCus.active,
                _customerId: this.props.selectedCus.customerId,
                nmbsRefer: this.props.selectedCus.nmbsReference,
                email: this.props.selectedCus.email,
                telephone: this.props.selectedCus.telephone,
                test: true
            }, () => {
            });
        }
        else {
            history.push('/admin-page');
        }
    }


    // pervents the list from redendering again 
    PopulateDropdownList() {
        console.log("cus list " + this.props.qloadCuslist);
        const cusList = this.props.qloadCuslist?.map(z => {
            return (
                <option key={z.id} value={z.id}>
                    {z.displayText}
                </option>
            )
        });
        this.setState({ customerListQload: cusList });
    }


    displayMessage = (type, title, message) => {
        this.setState({
            showAlert: true,
            typeAlert: type,
            titleAlert: title,
            messageAlert: message
        }, () => {
        });
    }

    handlePopUpMessage = () => {
        this.setState({ showAlert: false });

        if (this.state.userUpdatedSuccess == true) {
            history.push('/admin-page');
        }
    }

    //handleEmailChange = (email) => {
    //    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    //    if (re.test(email)) {
    //        // this is a valid email address
    //        // call setState({email: email}) to update the email
    //        // or update the data in redux store.
    //        this.setState({ email: email.target.value }, () => {
    //        });
    //    }
    //    else {
    //        // invalid email, maybe show an error to the user.
    //        alert.message("display is wrong");
    //    }
    //}

    handleEmailChange = (e) => {
        this.setState({ email: e.target.value }, () => {
        });
    }

    handleNMBSrefChange = (e) => {
        this.setState({ nmbsRefer: e.target.value }, () => {
        });
    }

    handlePhoneChange = e => {
        const re = /^(\d*\.)?\d+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ telephone: e.target.value }, () => {
            });
        };
    };

    onActiveToggle = (e) => {
        this.setState({
            active: e.target.value,
        });
    }


    async handleUpdate() {
        try {
            //validation 

            let { email } = this.state
            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        
            if (re.test(email) && (!isEmpty(this.state.email)) ) {
                if (email !== this.props.selectedCus.email) //checks if the email has been changed when in edit mode 
                {
                    const isEmailTaken = await this.isEmailTakenCall(this.props.selectedCus.loginId, email);
                    if (isEmailTaken) {
                        return this.displayMessage("error", `Email Address (${email}) is already taken`,
                            `The email address (${email}) is already being used, please enter a new one for this current user`
                        );
                    }
                }
            }
            else {
                this.displayMessage("error", "Invalid Email Address",
                    "This email address is invalid, please re-enter a valid emaill adress in order to update the selected user");
                return;
            }

            this.PeformUpdateCall();

        } catch (e) {

        }
    }

    passwordCheck() {

    }

    async isEmailTakenCall(selectedUsrId, emailAddress) {
        try {

            const token = await authService.getAccessToken();
            const response = await fetch(dataController + 'isemailtaken/', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    LoginId: selectedUsrId,
                    EmailAddress: emailAddress
                })
            })
                .then((response) => {
                    if (response.status === 401) {
                        throw new Error("Unauthorised request");
                    }
                    return response;
                })
                .then(res => res.json())
                .catch();

            return response;
        }
        catch (e) {
        }
    }


    async PeformUpdateCall() {
        try {
            let { email, telephone, _customerId, nmbsRefer, active } = this.state

            var errorFetching = false;

            const token = await authService.getAccessToken();
            const response = await fetch(dataController + 'updateuserDetails/', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    LoginId: this.props.selectedCus.loginId,
                    EmailAddress: email,
                    CustomerId: _customerId,
                    Telephone: telephone,
                    NMBSReference: nmbsRefer,
                    Active: active
                })
            })
                .then((response) => {
                    if (response.status === 401) {
                        throw new Error("Unauthorised request");
                    }
                    return response;
                })
                .then(res => res.json())
                .catch();

            if (response.isSuccess === true) {
                this.setState({ userUpdatedSuccess: true }, () => { });
                this.displayMessage("success", "User Updated Successfully!", response.message);
            }
            else {
                this.displayMessage("error", "Oops, an Error has Occurred", response?.message);
                return;
            }
        }
        catch (e) {
        }
    }

    onCusChange = (event) => {
        this.setState({ _customerId: parseInt(event.target.value) }, () => {
           
        });
    };



    render() {
        const { classes } = this.props;
        let { showAlert, typeAlert, titleAlert, messageAlert, customerListQload } = this.state


        return (
            <div className={classes.content}>
                <div style={{ width: "100%" }}>
                    <div style={{ padding: "10x" }}>
                        <h3 className={classes.title} style={{ borderBottom: "2px dashed grey", padding: "5px" }}>
                            <i class="far fa-user-circle"></i> {' '}
                            Account Details
                        </h3>

                        <Simplert
                            style={{
                                width: '250px;',
                            }}
                            showSimplert={showAlert}
                            type={typeAlert}
                            title={titleAlert}
                            message={messageAlert}
                            onClose={() => this.handlePopUpMessage()}
                            disableOverlayClick={true}
                            customCloseBtnClass={classes.closebuttonPopUp}    
                        />

                        <GridContainer>
                            <GridItem xs={12} sm={6} md={6}>
                                <TextField
                                    fullWidth
                                    id="bracnhLokUp"
                                    select
                                    label="Customer"
                                    SelectProps={{
                                        native: true,
                                        MenuProps: {
                                            className: classes.menu
                                        }
                                    }}
                                    helperText="Please select your customer"
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.onCusChange}
                                    value={this.props.selectedCus === null ? 0 : this.state._customerId ? this.state._customerId : 0}
                                >
                                    {customerListQload}
                                </TextField>
                            </GridItem>

                            <GridItem xs={12} sm={6} md={6}>
                                <TextField
                                    id="outlined-full-width"
                                    label="Email"
                                    fullWidth
                                    type="email"
                                    margin="normal"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    value={this.props.selectedCus === null ? '' : this.state.email ? this.state.email : ''}
                                    onChange={this.handleEmailChange}
                                    error={this.state.email !== "" && !this.state.email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)}
                                    helperText={this.state.email !== "" && !this.state.email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) ? 'Invalid Emaill Address.' : ' '}
                                />


                            </GridItem>
                            <GridItem xs={12} sm={6} md={6}>
                                <TextField
                                    id="outlined-full-width"
                                    label="Telephone"
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    value={this.props.selectedCus === null ? "" : this.state.telephone ? this.state.telephone : ''}
                                    onChange={this.handlePhoneChange}
                                    pattern="/\B(?=(\d{3})+(?!\d))/g"
                                    type="number"
                                />
                            </GridItem>

                            <GridItem xs={12} sm={6} md={6}>
                                <TextField
                                    id="outlined-full-width"
                                    label="NMBS Reference"
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    value={this.props.selectedCus === null ? "" : this.state.nmbsRefer ? this.state.nmbsRefer : ''}
                                    onChange={this.handleNMBSrefChange}
                                />
                            </GridItem>

                            <GridItem xs={12} sm={6} md={6}>
                                <TextField
                                    fullWidth
                                    id="product"
                                    select
                                    label="Product Category"                                    SelectProps={{
                                        native: true,
                                        MenuProps: {
                                            className: classes.menu
                                        }
                                    }}
                                    helperText="Please select a product Category"
                                    margin="normal"
                                    variant="outlined"
                                >
                                    {productCat.map(z => (
                                        <option key={z.value} value={z.value}>
                                            {z.label}
                                        </option>
                                    ))}
                                </TextField>
                            </GridItem>

                            <GridItem xs={12} sm={6} md={6}>
                                <FormControlLabel
                                    control={
                                        <Checkbox

                                            checkedIcon={
                                                <Check className={classes.checkedIcon} />
                                            }
                                            icon={
                                                <Check className={classes.uncheckedIcon} />
                                            }
                                            classes={{
                                                checked: classes.checked,
                                                root: classes.checkRoot,
                                            }}
                                            checked={this.props.selectedCus === null ? false : this.state.active ? this.state.active : false}
                                            onChange={(e) => {
                                                this.onActiveToggle({
                                                    target: {
                                                        name: e.target.name,
                                                        value: e.target.checked,
                                                    },
                                                });
                                            }}
                                        />
                                    }
                                    label={<h4><b>Active</b></h4>}
                                />
                            </GridItem>

                        </GridContainer>




                        <div>
                            <h3 className={classes.title} style={{ borderBottom: "2px dashed grey", padding: "5px" }}>
                                <i class="fas fa-unlock-alt"></i>
                                {' '}
                                Password Details</h3>
                            <SnackbarContent
                                message={
                                    <span>
                                        <b>Password Alert:</b> Only enter a <b> password </b> if you wish to update the current password!
                                    </span>
                                }
                                close
                                color="danger"
                                icon={Warning}

                            />
                            <GridContainer>
                                <GridItem xs={12} sm={6} md={6}>
                                    <TextField
                                        id="outlined-password-input"
                                        label="Password"
                                        type="password"
                                        autoComplete="current-password"
                                        placeholder="Password...."
                                        fullWidth
                                        margin="normal"
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={6} md={6}>
                                    <TextField
                                        id="outlined-password-input"
                                        label="Confirm Password"
                                        type="password"
                                        autoComplete="current-password"
                                        placeholder="Password...."
                                        fullWidth
                                        margin="normal"
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                    />
                                </GridItem>


                                <GridItem xs={12} sm={12} md={12} style={{ paddingTop: "40px" }}>
                                    <div className={classes.left}>
                                        <Button
                                            style={{
                                                borderRadius: 2,
                                                padding: "16px 20px",
                                                fontSize: "15px"
                                            }}
                                            color="danger"
                                            size="lg"
                                            target="_blank"
                                            onClick={() => history.goBack()}

                                        >
                                            <i className="far fa-window-close"></i>
                                            &nbsp; Cancel
                                        </Button>
                                    </div>

                                    <div className={classes.right}>
                                        <Button
                               
                                            style={{
                                             
                                                borderRadius: 2,
                                                padding: "16px 20px",
                                                fontSize: "15px"
                                            }}

                                            color="success"
                                            size="lg"
                                            target="_blank"
                                            onClick={() => this.handleUpdate()}
                                        >
                                            <i class="fas fa-check"></i>
                                            &nbsp;  Update
                                        </Button>
                                    </div>
                                </GridItem>
                            </GridContainer>

                        </div>
                    </div>
                </div>
            </div>


        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.userReducer.user,
        selectedCus: state.adminData.selectedCustomer,
        qloadCuslist: state.adminData.qloadCustomerList
    };
};

export default connect(mapStateToProps, { getSelectedCustomer, getQloadCustomerList })(withStyles(useStyles)(EditCusotmerFields));   // used to export both the styling and redux